<template>
    <div class="content" style="background-color: #fff;">
    	<div style="padding: .15rem .4rem;">
	        <div>
	        	<div class="table" style="margin-top: .3rem;">
					<div class="table-title">
                        <van-row type="flex">
                            <van-col span="6">日期</van-col>
                            <van-col span="8">坐席</van-col>
                            <van-col span="6">话费金额</van-col>
                            <van-col span="4">通话时长</van-col>
                        </van-row>
                    </div>
                    <div class="table-body">
                        <van-row class="table-null" v-if="list2.length==0">未查询到数据</van-row>
                        <van-row type="flex" class="table-tr" v-for="(item,index) in list2" :key="index">
                            <van-col span="6">{{item.createTimeStr}}</van-col>
                            <van-col span="8">{{item.createUserName}}</van-col>
                            <van-col span="6">{{item.money/100}}元</van-col>
                            <van-col span="4">{{item.durationStr}}</van-col>
                        </van-row>
                    </div>
				</div>
	        </div>
    	</div>
    </div>
</template>
<script type="text/javascript">
	import axios from 'axios';
    import {payList} from '../../api';
    export default {
        name: 'recharge',
        data() {
            return {
                list2:[]
            }
        },
        methods: {
        	getQueryString(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
                var r = window.location.search.substr(1).match(reg); 
                if (r != null) return decodeURI(r[2]); return ""; 
            },
            payListInfo(time){
                var time = this.getQueryString("time");
                payList({
                    timeStart:time,
                    timeEnd:time,
                    currentPage:1,
                    showCount:1000000,
                    orderType:2
                }).then((res) => {
                    if(res.code==1){
                        this.list2 = res.data.list;
                    }
                })
            },
        },
        mounted(){
            this.payListInfo();
    	}
	}
</script>


// WEBPACK FOOTER //
// src/views/order/consumptionDesc.vue


// WEBPACK FOOTER //
// src/views/order/consumptionDesc.vue